import { render, staticRenderFns } from "./LeaveAttachmentsTab.vue?vue&type=template&id=3164d92c"
import script from "./LeaveAttachmentsTab.vue?vue&type=script&lang=js"
export * from "./LeaveAttachmentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports